import { CommandResult } from '../commands';

export abstract class BaseResponse {
    commandResult: CommandResult;

    constructor(commandResult: CommandResult) {
        this.commandResult = commandResult;
    }
}
